import { render } from "./OpticSurfaceComponent.vue?vue&type=template&id=6cdbd58e"
import script from "./OpticSurfaceComponent.vue?vue&type=script&lang=js"
export * from "./OpticSurfaceComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Documents\\Github\\OpticTool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__